export default __webpack_public_path__ + "js/components/common/unlock-button-font-pally/lock-open-a6b2dd7651bd2788f93700c042b870a4.svg";